
<template>
  <v-container fluid full-width class="px-0">
    <v-layout v-if="!(manager && user)" align-center justify-center>
      <v-flex grow>
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-layout>
    <v-layout v-else row align-center justify-space-between>
      <v-flex md4 class="text-md-center">
        <h1 class="subheading subtle">Your VSS Manager</h1>
        <h1 class="display-1">{{ manager.name }}</h1>
      </v-flex>
      <v-flex v-if="manager.phone" md4 class="text-md-center">
        <h1 class="subheading subtle">Phone:</h1>
        <h1 class="display-1">{{ manager.phone }}</h1>
      </v-flex>
      <v-flex shrink md4 class="text-md-right">
        <MessagePopup
          color="primary"
          :recipientId="manager.id"
          :senderId="user.id"
          buttonText="Message VSS Manager"
          style="width: fit-content; margin: 0 auto;"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import MessagePopup from '@/components/base/message-popup.vue'

export default {
  components: {
    MessagePopup
  },
  props: [
    'manager'
  ],
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    exampleComputed: function () {
      return this.example
    },
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {
      example: 'test'
    }
  },
  methods: {
    exampleMethod () {
      
    },
  },
}
</script>

<style scoped>
</style>
